import { Link } from "react-router-dom";
import { Crown, AlertTriangle } from "lucide-react";
import { useUserStore } from "@/stores/user-store";
import { VIP_SUPPORT_EMAIL } from "@/config/vip";

export function VipBanner() {
  const { isWhale, vipAtRisk, generationsPurgeInDays } = useUserStore();

  if (!isWhale) return null;

  return (
    <>
      <div className="shrink-0 z-40 flex items-center justify-center gap-2 bg-gradient-to-r from-[#120e18] via-[#1a1228] to-[#120e18] border-b border-[#d4a574]/20 text-center text-[12px] font-semibold py-2 px-4">
        <Crown className="size-3.5 text-[#d4a574] shrink-0" />
        <span className="text-[#f0dcc0]">
          You are a <span className="text-[#d4a574]">VIP</span>
        </span>
        <span className="hidden sm:inline text-white/30">·</span>
        <span className="hidden sm:inline text-white/50 font-medium">
          Priority support & exclusive perks
        </span>
      </div>

      {vipAtRisk && (
        <div className="shrink-0 z-40 flex items-center justify-center gap-2 bg-amber-950/80 border-b border-amber-500/20 text-center text-[11px] sm:text-[12px] font-medium py-2 px-4">
          <AlertTriangle className="size-3.5 text-amber-400 shrink-0" />
          <span className="text-amber-100/90">
            {generationsPurgeInDays !== null && generationsPurgeInDays > 0 ? (
              <>
                No purchase in 30+ days — your generations will be removed in{" "}
                <strong>{generationsPurgeInDays} day{generationsPurgeInDays === 1 ? "" : "s"}</strong>{" "}
                unless you purchase.
              </>
            ) : (
              <>
                No purchase in 30+ days — your generations will be removed soon unless you purchase.
              </>
            )}{" "}
            <Link to="/billing" className="text-[#d4a574] hover:underline font-semibold">
              Buy gizmos
            </Link>
            {" · "}
            Questions?{" "}
            <a
              href={`mailto:${VIP_SUPPORT_EMAIL}`}
              className="text-[#d4a574] hover:underline font-semibold"
            >
              {VIP_SUPPORT_EMAIL}
            </a>
          </span>
        </div>
      )}
    </>
  );
}
